import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { UsuarioService } from '@account/usuario.service';
import { ComprobanteService } from '@facturacion/comprobante.service';
import { MessageService } from '@shell/message.service';
import { TransaccionesService } from '@stock/transacciones.service';
import { ReporteMovimiento } from '@shared/models/cierreTurno/ReporteMovimiento';
import { Aeroplanta } from '@shared/models/despacho/Aeroplanta';
import { ComprobanteSalida } from '@shared/models/stock/ComprobanteSalida';
import { Transaccion } from '@shared/models/stock/Transaccion';
import { Recepcion } from '@shared/models/stock/Recepcion';
import { TipoComprobanteMovimiento } from '@shared/enums/TipoComprobanteMovimiento';
import { RecepcionCombustibleContenedor } from '@shared/models/stock/RecepcionCombustibleContenedor';

@Component({
  selector: 'app-visor-comprobante-cargamento',
  templateUrl: './visor-comprobante-cargamento.component.html',
  styleUrls: ['./visor-comprobante-cargamento.component.css']
})
export class VisorComprobanteCargamentoComponent implements OnInit {
  @Input() movimiento: Transaccion;
  @Input() comp: TipoComprobanteMovimiento;
  @Input() comprobanteEnviado: ReporteMovimiento;
  @Input() recepcion: Recepcion;
  @Input() datosMuestra: RecepcionCombustibleContenedor[];

  operadorImagePath;
  clienteImagePath;

  obteniendoComprobante: boolean = false;
  obteniendoAeroplanta: boolean = false;

  aeroplantaActual: Aeroplanta;
  aeroplanta: Aeroplanta[] = [];

  comprobante: ComprobanteSalida = null;
  TipoComprobanteMovimiento = TipoComprobanteMovimiento;

  constructor(private transaccionService: TransaccionesService, private spinner: NgxSpinnerService, private sanitizer: DomSanitizer, private usuarioService: UsuarioService,
    private comprobanteService: ComprobanteService, private messageService: MessageService) { }

  ngOnInit() {
    this.obteniendoComprobante = true;
    this.aeroplantaActual = this.usuarioService.getAeroplantaActual();
    this.obtenerAeroplanta();
    this.spinner.show('spinnerComprobante');
    if(this.movimiento != null){
    this.transaccionService.getTransaccionPorIdConComprobante(this.movimiento.id)
      .subscribe(result => {
        this.comprobante = result;
        this.generarResourceUrls();
        this.spinner.hide('spinnerComprobante');
        this.obteniendoComprobante = false;
      });
    }else{
      this.transaccionService.getTransaccionPorIdConComprobante(this.comprobanteEnviado.transaccionId)
      .subscribe(result => {
        this.comprobante = result;
        this.movimiento = new Transaccion();
        this.movimiento.fechaHora = this.comprobanteEnviado.fechaHora;
        this.generarResourceUrls();
        this.spinner.hide('spinnerComprobante');
        this.obteniendoComprobante = false;
      });
    }
  }

  obtenerAeroplanta() {
    this.obteniendoAeroplanta = true;
    this.comprobanteService.getDatosAeroplanta(this.aeroplantaActual.codigoAeroplanta)
      .subscribe(result => {
        this.aeroplanta = result;
        this.obteniendoAeroplanta = false;
      }, () => {
        this.messageService.showErrorMessage('Hubo un error al obtener los datos de la aeroplanta.')
      });
  }

  ImagenFirmaOperador(): string{
    let firma : string = ""

    if (this.comprobante.remitoAeroespecialidad != null &&  this.comprobante.remitoAeroespecialidad.reciboCargamento.firmaOperador != null){
      firma = this.comprobante.remitoAeroespecialidad.reciboCargamento.firmaOperador;
    }

    if (this.comprobante.remitoCargamento != null && this.comprobante.remitoCargamento.reciboCargamento.firmaOperador != null){
      firma = this.comprobante.remitoCargamento.reciboCargamento.firmaOperador; 
    }

    return firma;
  }

  obtenerDescripcionMuestra(codigoProducto) {
    const detalleProducto = this.recepcion.detalles.find(d => d.codigoProducto == codigoProducto);
    return detalleProducto.nombreProducto;
  }

  obtenerDensidadMuestra(codigoProducto) {
    const detalleProducto = this.recepcion.detalles.find(d => d.codigoProducto == codigoProducto);
    return detalleProducto.calidadProducto.densidad.toFixed(3);
  }
  
  obtenerTemperaturaMuestra(codigoProducto) {
    const detalleProducto = this.recepcion.detalles.find(d => d.codigoProducto == codigoProducto);
    return detalleProducto.calidadProducto.temperatura;
  }

  obtenerCantidadMuestra(codigoProducto) {
    let cantidad = 0;
    this.recepcion.recepciones.forEach(r => {
      if(r.codigoProducto == codigoProducto) {
        cantidad += r.medicionFinal.nivelNatural;
        cantidad -= r.medicionPrevia.nivelNatural;
      }
    })
    return cantidad;
  }

  obtenerCantidad15Muestra(codigoProducto) {
    let cantidad15 = 0;
    this.recepcion.recepciones.forEach(r => {
      if(r.codigoProducto == codigoProducto) {
        cantidad15 += r.medicionFinal.nivel;
        cantidad15 -= r.medicionPrevia.nivel;
      }
    })
    return cantidad15;
  }

  obtenerAptoMuestra(codigoProducto) {
    const detalleProducto = this.recepcion.detalles.find(p => p.codigoProducto == codigoProducto);
    const apto = detalleProducto.calidadProducto.aptoCalidad ? 'Si' : 'No';
    return apto;
  }

  obtenerDiferenciaMuestra(codigoProducto) {
    const detalleProducto = this.recepcion.detalles.find(p => p.codigoProducto == codigoProducto);
    return this.obtenerCantidad15Muestra(codigoProducto) - detalleProducto.detalleCombustible.cantidad15;
  }

  CompletarPrefijo(prefijo: number) {
    const p = prefijo;
    return p.toString().padStart(5, '0')
  }
  CompletarNumero(numero: number) {
    const n = numero;
    return n.toString().padStart(8, '0')
  }

  ImagenFirmaConductor(): string{
    let firma : string = ""

    if (this.comprobante.remitoAeroespecialidad != null &&  this.comprobante.remitoAeroespecialidad.reciboCargamento.firmaConductor != null){
      firma = this.comprobante.remitoAeroespecialidad.reciboCargamento.firmaConductor;
    }

    if (this.comprobante.remitoCargamento != null && this.comprobante.remitoCargamento.reciboCargamento.firmaConductor != null){
      firma = this.comprobante.remitoCargamento.reciboCargamento.firmaConductor; 
    }

    return firma;
  }

  ImagenRemito(): string{
    let imgRemito : string = "";

    if (this.comprobante.remitoAeroespecialidad != null &&  this.comprobante.remitoAeroespecialidad.pathRemitoFisico != null){
      imgRemito = this.comprobante.remitoAeroespecialidad.pathRemitoFisico; 
    }

    if (this.comprobante.remitoCargamento != null && this.comprobante.remitoCargamento.pathRemitoFisico != null){
      imgRemito = this.comprobante.remitoCargamento.pathRemitoFisico; 
    }
    
    return imgRemito;
  }

  generarResourceUrls() {
    if(this.comprobante.remitoCargamento && this.comprobante.remitoCargamento.reciboCargamento != null){
      this.operadorImagePath = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + this.comprobante.remitoCargamento.reciboCargamento.firmaOperador);
      this.clienteImagePath = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + this.comprobante.remitoCargamento.reciboCargamento.firmaConductor);
    }    
  }

  set_format_cuit(cuit: string) {
    cuit = cuit.substr(0, 2) + - + cuit.substr(2, 8) + - + cuit.substr(10);
    return (cuit)
  }
}
